import { createBooleanOverride } from 'core/dev-toolbox';

/**
 * Dev Toolbox → Custom Overrides → Onboarding Wizard
 * - true: show FAB (also clears dismiss)
 * - false: hide FAB
 * - unset: normal dismiss / task rules
 */
export const useOnboardingWizardForceVisibleOverride = createBooleanOverride(
  'onboardingWizardForceVisible',
  { group: 'onboardingWizard' }
);
